import React, { Component } from "react";
import { Link } from "react-router-dom";
class CityXApp_Sidebar extends Component {
  render() {
    return (
      <div id="sidebar">
        <div
          className="themesflat-spacer clearfix"
          data-desktop={80}
          data-mobile={0}
          data-smobile={0}
        />
        <div id="inner-sidebar" className="inner-content-wrap">
          <div className="widget widget_list">
            <div className="inner">
              <ul className="list-wrap">
                <li className="list-item">
                  <Link
                    to="/apps/cityx-app"
                    onClick={() => {
                      window.location.href = "/apps/cityx-app";
                    }}
                  >
                    <span className="text">CityX App</span>
                  </Link>
                </li>
                <li className="list-item">
                  <Link
                    to="#"
                    onClick={() => {
                      window.location.href = "/partners?type=cities";
                    }}
                  >
                    <span className="text">Pregled gradova</span>
                  </Link>
                </li>
                <li className="list-item">
                  <Link
                    to="/apps/cityx-app-new-biz"
                    onClick={() => {
                      window.location.href = "/apps/cityx-app-new-biz";
                    }}
                  >
                    <span className="text">Dodaj business</span>
                  </Link>
                </li>
                <li className="list-item">
                  <Link
                    to="/apps/cityx-app-edit-biz"
                    onClick={() => {
                      window.location.href = "/apps/cityx-app-edit-biz";
                    }}
                  >
                    <span className="text">Predloži promjenu podataka</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="widget widget_help align-center has-shadow no-sep has-border border-solid">
            <div className="inner">
              <h2 className="widget-title margin-bottom-14">
                <span>Kako Vam mogu pomoći?</span>
              </h2>
              <p className="text line-height-26 margin-bottom-23">
                <img
                  src="../assets/img/employees/katarina.jpeg"
                  alt="Katarina Babić, CityX Apps"
                />
                <br />
                <br />
                Za ugovaranje CityX App-a u Vašem gradu, rado će Vam pomoći{" "}
                <b>Katarina Babić</b>.
              </p>
              <div className="elm-button">
                <a href="/contact" className="themesflat-button bg-accent pd30">
                  KONTAKTIRAJTE ME
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          className="themesflat-spacer clearfix"
          data-desktop={0}
          data-mobile={60}
          data-smobile={60}
        />
      </div>
    );
  }
}

export default CityXApp_Sidebar;
